module.exports = __webpack_public_path__ + "static/media/figure9.53971531.png";